import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'

export const COUNTDOWN_FORM_ID = 'countdown-form'
export const MIN_COUNTDOWN_MINUTES = 0
export const MAX_COUNTDOWN_MINUTES = 60

const schema = z.object({
  minutes: z.number().min(1).max(MAX_COUNTDOWN_MINUTES),
})

export type CountdownFormValues = z.infer<typeof schema>
export const countdownFormResolver = zodResolver(schema)
